import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'mojo-hours-minutes',
  templateUrl: './hours-minutes.component.html'
})
export class HoursMinutesComponent implements OnInit {

  @Input() disabled: boolean;

  @Input() timeString: string;
  
  @Output('onChange') onChange = new EventEmitter<string>();

  @Input() style: string;
  @Input() styleClass: string;

  constructor() { }

  ngOnInit(): void {
  }

  timeStringChanged(): void {
    this.limitTimeString()
    this.onChange.emit(this.timeString)
  }

  limitTimeString(): void {
    let hours = 0
    let mins = 0
    if (this.timeString) {
      let parts = this.timeString.split(':')
      if (parts.length == 2) {
        hours = Number(parts[0])
        hours = hours > 23 ? 23 : hours
        mins = Number(parts[1])
        mins = mins > 59 ? 59 : mins
      }
    }
    let hoursString = hours < 10 ? `0${hours}` : `${hours}`
    let minsString = mins < 10 ? `0${mins}` : `${mins}`
    this.timeString = `${hoursString}:${minsString}`
  }

}
